export class HospicePatientPayer {
    public Id: string;
    public AgencyPayorId: string;
    public AgencyPayorName: string;
    public Type: number;
    public BillAsType: number;
    public MedicarePartAEffectiveDate: string;
    public EffectiveDate: string;
    public MemberId: string;
    public GroupName: string;
    public GroupId: string;
    public RelationshipToInsured: number = null;
    public EmployerName: string;
    public DeductibleAmount: number;
    public DeductibleMet: boolean;
    public CopayAmount: number;
    public CaseManager: string;
    public OutOfPocketAmount: number;
    public OutOfPocketMet: boolean;
    public IsMedicare: boolean;
    public IsCharity: boolean;
    public Comments: string;
    public SubscriberFirstName: string;
    public SubscriberLastName: string;
    public HasAttachedVisits: boolean;
    public BillType: number;
    public ContactId: string;
    public Liabilities: string[];
    public AreBenefitsVerified: boolean;
    public IsOutOfPocketMaxMet?: boolean;
    public RequirePriorAuthorization?: boolean;
    public IsBenefitVerified?: boolean;
    public AgencyId?: string;

    public constructor(data?: any) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
